import { Component, OnInit, Input, Inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { asEnumerable, AsEnumerable } from 'linq-es2015';
import { SeedRequest } from '../../../shared/services/seed-request.service';
import { ResolvedSeedRequestsService, SEED_REQUESTS } from '../../services/resolved-seed-requests.module';

@Component({
  selector: 'app-seed-requests',
  templateUrl: './seed-requests.component.html',
  styleUrls: ['./seed-requests.component.css'],
  providers: [
    { provide: SEED_REQUESTS, useClass: ResolvedSeedRequestsService }
  ]
})
export class SeedRequestsComponent {
  @Input() experimentDesignFormGroup: FormGroup

  private seedRequests: SeedRequest[];

  public get anySeedRequests(): boolean {
    return AsEnumerable(this.seedRequests).Any();
  }

  constructor(@Inject(SEED_REQUESTS) private seedRequestsService: ResolvedSeedRequestsService) {
    this.seedRequests = asEnumerable(seedRequestsService.seedRequests)
                          .OrderByDescending(r => r.batchId)
                          .ToArray();
  }
}



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/request-creation/experiment-design/seed-requests/seed-requests.component.ts